import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './App.css';

function Hakedis() {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState('aktif');
  const [editingUser, setEditingUser] = useState(null);
  const [editedHakedis, setEditedHakedis] = useState('');
  const username = localStorage.getItem('username');
  const [excelFile, setExcelFile] = useState(null);

  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const nextYear = currentYear + 1;

  useEffect(() => {
    fetchUsers('aktif');
  }, []);

  const fetchUsers = (userType) => {
    let apiUrl = '';
    if (userType === 'aktif') apiUrl = 'https://api.idekod.com.tr/hakedis';
    else if (userType === 'bekleyen') apiUrl = 'https://api.idekod.com.tr/bekleyen';
    else if (userType === 'pasif') apiUrl = 'https://api.idekod.com.tr/pasif';

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setUsers(Array.isArray(data) ? data : []);
      })
      .catch((error) => console.error('Error:', error));
  };

  const startEditing = (user) => {
    setEditingUser(user.PK);
    setEditedHakedis(user[`${currentYear}`]);
  };

  const confirmEdit = (user) => {
    if (window.confirm('Değişiklikleri kaydetmek istiyor musunuz?')) {
      fetch('https://api.idekod.com.tr/hakedisupdate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ PK: user.PK, year: currentYear, hakedis: editedHakedis }),
      })
        .then((response) => response.json())
        .then(() => {
          fetchUsers(filter);
          cancelEditing();
        })
        .catch((error) => console.error('Error:', error));
    }
  };

  const cancelEditing = () => {
    setEditingUser(null);
    setEditedHakedis('');
  };

  const handleFileChange = (e) => setExcelFile(e.target.files[0]);

  const handleExcelSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', excelFile);

    try {
      const response = await fetch('https://api.idekod.com.tr/api/users/excelhakedis', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        alert('Kullanıcılar başarıyla eklendi!');
      } else {
        alert('Excel dosyasından kullanıcı ekleme başarısız oldu.');
      }
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  const handleTransfer = () => {
    users.forEach(user => {
      const currentHakedis = user[currentYear] || 0;
      const additionalHakedis = user[previousYear] || 0;
      const newHakedis = currentHakedis + additionalHakedis;

      fetch('https://api.idekod.com.tr/hakedistransfer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          PK: user.PK,
          year: currentYear,
          hakedis: newHakedis,
          aktarimKullanici: username,
        }),
      })
        .then(response => response.json())
        .then(() => fetchUsers(filter))
        .catch(error => console.error('Aktarım hatası:', error));
    });
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Kullanıcılar');
    XLSX.writeFile(workbook, 'Hakediş.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const tableColumn = [
      'Adı', 'Telefon', 'Durum', 'Başlangıç Tarihi',
      `Hak Ediş (${previousYear})`, `Hak Ediş (${currentYear})`, `Hak Ediş (${nextYear})`,
    ];
    const tableRows = users.map((user) => [
      user.RNAME, user.telno, user.STATE,
      new Date(user.girist).toLocaleDateString('tr-TR'),
      user[previousYear], user[currentYear], user[nextYear],
    ]);
    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save('Hakediş.pdf');
  };

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">Hakediş Yönetimi</h1>
          <p className="page__subtitle">Yıllık izin hakedişlerini düzenleyin, aktarın ve dışa alın</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Excelden Aktar</h2>
          <p className="card__subtitle">Toplu hakediş yüklemek için şablona uygun bir dosya seçin.</p>
        </div>

        <div className="card__body">
          <form onSubmit={handleExcelSubmit} className="form">
            <div className="form-field">
              <label className="form-label">Excel Dosyası (.xlsx, .xls)</label>
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                required
                className="form-control"
              />
            </div>
            <div className="btn-group">
              <button type="submit" className="btn btn--primary">Excelden Aktar</button>
              <button
                type="button"
                onClick={() => window.location.href = 'http://pdks.idekod.com.tr/indirmeler/hakedis.xlsx'}
                className="btn btn--ghost"
              >
                Örnek Dosyayı İndir
              </button>
              <button type="button" onClick={exportToExcel} className="btn btn--ghost">Excel'e Aktar</button>
              <button type="button" onClick={exportToPDF} className="btn btn--ghost">PDF'e Aktar</button>
            </div>
          </form>
        </div>

        <div className="card__body">
          <h3 className="section-title">Yıl Devri</h3>
          <div className="u-flex u-items-center u-gap-3 u-flex-wrap">
            <span className="badge">{previousYear}</span>
            <span style={{ color: 'var(--color-text-muted)' }}>&#8594;</span>
            <span className="badge badge--info">{currentYear}</span>
            <button onClick={handleTransfer} className="btn btn--primary btn--sm">
              Kalanları Aktar
            </button>
          </div>
          <p className="form-helper u-mt-2">
            {previousYear} yılından kalan hakedişler {currentYear} yılına eklenir.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Personel Hakedişleri</h2>
        </div>

        <div className="table-wrapper">
          <table className="data-table data-table--striped">
            <thead>
              <tr>
                <th>Adı</th>
                <th>Telefon</th>
                <th>Durum</th>
                <th>Başlangıç Tarihi</th>
                <th>Hakediş ({previousYear})</th>
                <th>Hakediş ({currentYear})</th>
                <th>Hakediş ({nextYear})</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.PK}>
                  <td data-label="Adı">{user.RNAME}</td>
                  <td data-label="Telefon">{user.telno}</td>
                  <td data-label="Durum">{user.STATE}</td>
                  <td data-label="Başlangıç">{new Date(user.girist).toLocaleDateString('tr-TR')}</td>
                  <td data-label={`Hakediş ${previousYear}`}>{user[previousYear]}</td>
                  <td data-label={`Hakediş ${currentYear}`}>
                    {editingUser === user.PK ? (
                      <input
                        type="number"
                        value={editedHakedis}
                        onChange={(e) => setEditedHakedis(e.target.value)}
                        className="form-control"
                        style={{ maxWidth: 120 }}
                        aria-label={`${user.RNAME} ${currentYear} hakedişi`}
                      />
                    ) : (
                      user[currentYear]
                    )}
                  </td>
                  <td data-label={`Hakediş ${nextYear}`}>{user[nextYear]}</td>
                  <td data-label="İşlemler">
                    <div className="actions-cell">
                      {editingUser === user.PK ? (
                        <>
                          <button onClick={() => confirmEdit(user)} className="btn btn--success btn--sm">Kaydet</button>
                          <button onClick={cancelEditing} className="btn btn--danger btn--sm">İptal</button>
                        </>
                      ) : (
                        <button onClick={() => startEditing(user)} className="btn btn--primary btn--sm">Düzenle</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr className="empty-row">
                  <td colSpan="8">Kayıt bulunamadı.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Hakedis;
